<div class="container">
  <p>Price ($) {{range[0]}}{{divider}}{{range[1]}}</p>
  <nouislider
    #slider
    [connect]="true"
    [config]="config"
    [(ngModel)]="modelRange"
    (ngModelChange)="onChange($event)"
  ></nouislider>
</div>
